import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Router } from '@angular/router';
import { fuseAnimations } from '../../../../../../core/animations';
import { AuthenticationService } from '../../../../../services/authentication/authentication.service';
import { DivisionService } from '../../../../../services/divisions/division.service';
import { ShiftService } from '../../../../../services/shifts/shift.service';
import { SweetAlertService } from '../../../../../services/sweet-alert/sweet-alert.service';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'fuse-add-edit-divisionr',
    templateUrl: 'add-edit-subject-course.component.html',
    styleUrls: ['./add-edit-subject-course.component.scss'],
    animations: fuseAnimations
})
export class AddEditSubjectCourseComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUIList: NgBlockUI;
    subjectCourseFormGroup;
    subjectFormControl;
    periodsFormControl;

    ngOnDestroy(): void {
    }

    ngOnInit(): void {
    }

    constructor(private authenticationService: AuthenticationService,
                @Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<AddEditSubjectCourseComponent>,
                public dialog: MatDialog,
                public divisionService: DivisionService,
                public shiftService: ShiftService,
                private router: Router,
                private fb: FormBuilder,
                private sweetAlertService: SweetAlertService) {
        this.initializeFormControlValidators();
    }

    initializeFormControlValidators() {
        this.subjectCourseFormGroup = this.fb.group({
            subjectFormControl: ['', [Validators.required]],
            periodsFormControl: ['', [Validators.required]],
        });
    }

    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    save() {
        if (this.data.mode === 'new') {
            const result = this.data.subject;

            result.Name = this.data.subjects.find(e => e.Id === result.SubjectId).Name;
            this.dialogRef.close(result);
        } else {
            console.log('editar');
            this.dialogRef.close(this.data.subject);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/curricula/add-edit-subject-course/add-edit-subject-course.component.ts